<template>
  <pt-live-list-detail class="pt-live-list-detail__withData" v-loading="loading" :value="currentLive" @deleteLive="toDeleteLive"></pt-live-list-detail>
</template>

<script>
import PtLiveListDetail from './index'
export default {
  name: 'pt-live-list-detail__withData',
  components: {
    'pt-live-list-detail': PtLiveListDetail
  },
  data () {
    return {
      loading: false,
      currentLive: {}
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$store.dispatch('getLiveDetail', this.$route.params.id).then(data => {
        this.loading = false
        this.currentLive = data.data
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    toDeleteLive (row) {
      this.$confirm(`确定要删除直播：${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deteleLive', row.id).then(data => {
          this.$message.success('删除成功！')
          this.loading = false
        }).catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
